import { BASE_URL_1 } from "App/constants"
import { isNull } from "App/utils/helpers"
import { isArray } from "lodash"

export const URL_SETTING = `${BASE_URL_1}/setting/list`;

export const KODE_PRINTER_SETTING = {
  printer_antrian_poliklinik: "PRINTER_ANTRIAN_POLIKLINIK",
  printer_antrian_poliklinik_thermal: "PRINTER_ANTRIAN_POLIKLINIK_THERMAL",
  printer_antrian_poliklinik_dot_matrix:
    "PRINTER_ANTRIAN_POLIKLINIK_DOT_MATRIX",
  printer_antrian_booking: "PRINTER_ANTRIAN_BOOKING",

  printer_gelang: "PRINTER_GELANG_DEWASA",
  printer_gelang_bayi: "PRINTER_GELANG_BAYI",
  printer_label: "PRINTER_LABEL",
  printer_label_x: "PRINTER_LABEL_X",

  printer_kartu_rm: "PRINTER_KARTU_RM",
  printer_rincian_tagihan: "PRINTER_RINCIAN_TAGIHAN",
  printer_rincian_penjualan: "PRINTER_RINCIAN_PENJUALAN",
  printer_kwitansi_penjualan: "PRINTER_KWITANSI_PENJUALAN",
  printer_sep_loket: "PRINTER_SEP_LOKET",
}

export const defaultHeadCells = [
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const accessCode = {
  gudang_farmasi: "GDG",
  gudang_logistik: "GDG",
  gudang_fixed_asset: "GDG",
}

export const MSG_NOT_MINUS = "Qty tidak boleh minus"

export const removeZeroInFront = (str) => {
  return str.replace(/^0+/, "")
}

export const itSelfEmpty = (str, rtrn = "", callback = undefined) => {
  return isNull(str) ? rtrn : isNull(callback) ? str : callback
}

export const objToValidArray = (data) => {
  return isArray(data) ? data : Object.values(JSON.parse(JSON.stringify(data)))
}

export const createValidQueryParams = (
  paramsValid,
  formFilter,
  except = [],
  callback,
) => {
  const query = []
  paramsValid.map((item) => {
    const checkField = formFilter[item.mask]
    if (!isNull(checkField)) {
      const exceptFilterFunc = except.filter((e) => e === item.valid)
      if (exceptFilterFunc.length > 0) {
        callback(query, item.valid)
      } else {
        query.push(`${item.valid}=${checkField}`)
      }
    }

    return true
  })

  return query.join("&")
}

export const handleOnFocusFreezeTable = () => {
  const freezeTable = document.getElementsByClassName("table-freeze")
  const freezeTableLength = freezeTable.length
  if (freezeTableLength > 0) {
    for (let i = 0; i < freezeTableLength; i++) {
      /**
       * NOTES
       *
       * class table-freeze-header is <thead/>
       * because we use tab, table-freeze-header can more than 1
       *
       */

      const freezeHeadersElm = document.getElementsByClassName(
        "table-freeze-header",
      )

      if (freezeHeadersElm.length > 0) {
        const freezeHeaders = freezeHeadersElm[i]?.children[0]?.children

        if (!isNull(freezeHeaders)) {
          for (let j = 0; j < 4; j++) {
            if (!isNull(freezeHeaders[j])) {
              freezeHeaders[j].style.zIndex = `0`
            }
          }
        }
      }
    }
  }
}

export const handleOnBlurFreezeTable = () => {
  const freezeTable = document.getElementsByClassName("table-freeze")
  const freezeTableLength = freezeTable.length
  if (freezeTableLength > 0) {
    for (let i = 0; i < freezeTableLength; i++) {
      /**
       * NOTES
       *
       * class table-freeze-header is <thead/>
       * because we use tab, table-freeze-header can more than 1
       *
       */

      const freezeHeadersElm = document.getElementsByClassName(
        "table-freeze-header",
      )

      if (freezeHeadersElm.length > 0) {
        const freezeHeaders = freezeHeadersElm[i]?.children[0]?.children

        if (!isNull(freezeHeaders)) {
          for (let j = 0; j < 4; j++) {
            if (!isNull(freezeHeaders[j])) {
              freezeHeaders[j].style.zIndex = `2`
            }
          }
        }
      }
    }
  }
}

export function ucFirst(kalimat) {
  const kalimatAwal = kalimat.toLowerCase()
  const kataKata = kalimatAwal.split(" ")

  // Membuat array baru untuk menyimpan kata-kata yang telah diubah
  const kataKataBaru = []

  // Melakukan iterasi pada setiap kata
  for (let i = 0; i < kataKata.length; i++) {
    const kata = kataKata[i]

    // Mengubah huruf pertama kata menjadi huruf besar dan menggabungkannya dengan sisa kata
    const kataBaru = kata.charAt(0).toUpperCase() + kata.slice(1)

    // Menambahkan kata yang telah diubah ke dalam array kata-kata baru
    kataKataBaru.push(kataBaru)
  }

  // Menggabungkan kata-kata baru menjadi kalimat baru
  let kalimatBaru = kataKataBaru.join(" ")

  return kalimatBaru
}

export const messageError = {
  required: "Wajib Diisi",
}

export const checkJsonString = (dataOBJ) => {
  let dx = []
  try {
    dx = JSON.parse(dataOBJ)
  } catch (error) {
    dx = dataOBJ
  }
  dataOBJ = dx

  return dataOBJ
}

export const escapeWhiteSpace = (str) => {
  return str.replace(/\s/g, "")
}
export const getLabelCaraMasuk = (id) => {
  switch (id) {
    case "gp":
      return "Rujukan FKTP"
    case "hosp-trans":
      return "Rujukan FKRTL"
    case "mp":
      return "Rujukan Spesialis"
    case "outp":
      return "Dari Rawat Jalan"
    case "inp":
      return "Dari Rawat Inap"
    case "emd":
      return "Dari Rawat Darurat"
    case "born":
      return "Lahir di RS"
    case "nursing":
      return "Rujukan Panti Jompo"
    case "psych":
      return "Rujukan dari RS Jiwa"
    case "rehab":
      return "Rujukan Fasilitas "
    case "other":
      return "Lain-lain"

    default:
      return ""
  }
}
